import ListProduct from "../ListProduct";

interface props {
    tableId: string;
    setIsCate: (value: boolean) => void;
}

export default function Homepage({ tableId, setIsCate }: props) {
    return (
        <>
            <div className="pl-4 pr-2">
                <ListProduct tableId={tableId ? tableId : ""} setIsCate={setIsCate} />
            </div>
        </>
    )
}
